/**
 * Download and print the invoice PDF that is on screen — the same bytes, so a
 * printed or saved copy cannot differ from what the admin looked at.
 */

const asBlob = (bytes) => new Blob([bytes], { type: "application/pdf" });

export function downloadPdf(bytes, fileName = "invoice.pdf") {
  const url = URL.createObjectURL(asBlob(bytes));
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
}

/**
 * Print the PDF itself through the browser's PDF viewer in a hidden frame.
 * A browser with no inline PDF viewer (most phones) gets the PDF in a new tab
 * instead, to print or share from there. Call it straight from a click, so
 * the new tab is not taken for a pop-up.
 */
export function printPdf(bytes) {
  const url = URL.createObjectURL(asBlob(bytes));
  const openInTab = () => window.open(url, "_blank", "noopener");
  if (typeof navigator !== "undefined" && navigator.pdfViewerEnabled === false) {
    openInTab();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
    return;
  }
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.title = "Invoice for printing";
  Object.assign(frame.style, { position: "fixed", right: "0", bottom: "0", width: "0", height: "0", border: "0" });
  frame.onload = () => {
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    } catch {
      openInTab();
    }
    // The print dialog holds the document; give it time before letting go.
    setTimeout(() => { frame.remove(); URL.revokeObjectURL(url); }, 60000);
  };
  frame.src = url;
  document.body.appendChild(frame);
}
